import * as React from 'react';
export const sunbitSvg = React.forwardRef(function sunbitSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#002169',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm19.54 20.435 2.758 5.248c.145.254.435.326.653.145a11.936 11.936 0 0 0 2.868-2.86c.145-.217.072-.542-.146-.651l-5.226-2.751h-.037c-.254.29-.544.615-.87.869Zm-2.723 1.23-.218 5.756c0 .326.254.58.58.58a13.25 13.25 0 0 0 3.74-.978c.326-.145.435-.543.254-.796l-3.086-4.851s0-.036-.036-.036c-.4.144-.798.253-1.198.325-.036-.036-.036-.036-.036 0Zm10.672-5.031-5.844.217h-.037a6.817 6.817 0 0 1-.326 1.23l.036.037 4.937 3.113c.254.145.58.072.726-.217.544-1.231.907-2.498 1.016-3.837.036-.326-.218-.58-.508-.543ZM11.59 19.53l-5.264 2.75c-.254.145-.327.435-.145.652a11.933 11.933 0 0 0 2.867 2.86c.218.145.545.072.654-.145l2.758-5.212v-.037c-.326-.217-.617-.543-.87-.868Zm2.323 1.773-3.085 4.851c-.182.29-.073.688.254.796 1.198.543 2.432.87 3.738.978a.517.517 0 0 0 .581-.58l-.218-5.755v-.072a5.79 5.79 0 0 1-1.197-.326c-.037.108-.037.108-.073.108Zm-3.557-4.453-5.844-.217c-.29 0-.545.254-.509.543a11.55 11.55 0 0 0 1.017 3.838c.109.253.472.361.726.217l4.936-3.15.037-.036a9.314 9.314 0 0 1-.363-1.194c.036 0 .036 0 0 0Z',
      fill: '#3156DB',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm18.05 10.66 3.086-4.85c.182-.29.073-.688-.254-.796a11.199 11.199 0 0 0-3.739-.978.517.517 0 0 0-.58.58l.217 5.755v.037c.472.036.872.144 1.27.253 0 .036 0 .036 0 0Zm2.36 1.775 5.227-2.751c.254-.145.327-.435.145-.652a11.937 11.937 0 0 0-2.867-2.86c-.218-.145-.544-.072-.653.145l-2.76 5.213c.364.29.654.579.908.905Zm1.198 2.715 5.844.217c.29 0 .545-.254.508-.543a11.55 11.55 0 0 0-1.016-3.837c-.109-.254-.472-.362-.726-.217l-4.937 3.113h-.036c.182.434.29.832.363 1.267Zm-9.147-3.584L9.702 6.317c-.145-.253-.435-.326-.653-.145a11.935 11.935 0 0 0-2.868 2.86c-.145.217-.072.543.146.652l5.227 2.75h.036c.254-.289.544-.615.871-.868Zm2.722-1.231.218-5.756a.573.573 0 0 0-.58-.579c-1.307.145-2.541.47-3.74.978-.326.144-.435.543-.253.796l3.085 4.85.036.037c.4-.145.799-.253 1.198-.326.036.036.036.036.036 0Zm-4.501 3.548L5.746 10.77a.512.512 0 0 0-.726.217c-.545 1.23-.908 2.497-1.017 3.837-.036.29.218.543.509.543l5.844-.217h.036a6.69 6.69 0 0 1 .327-1.231s-.037 0-.037-.036Z',
      fill: '#FF9E4E',
    }),
  );
});
sunbitSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sunbit = {
  category: 'brand',
  colorable: false,
  name: 'sunbit',
  svg: sunbitSvg,
};
